module.exports = __webpack_public_path__ + "static/media/asset-1.b5b1240d.svg";